import { useEffect } from "react";
import MobileProjectMenu from "../Mobile/MobileProjectMenu";

function Project({
  role,
  title,
  billing,
  imageSrc,
  projectKey,
  setCurrentProject,
}) {
  // Keep currentProject in sync with the route actually being viewed,
  // so image-cycling math always uses this project's image array length.
  useEffect(() => {
    if (projectKey && setCurrentProject) {
      setCurrentProject(projectKey);
    }
  }, [projectKey, setCurrentProject]);

  return (
    <div className="project">
      <MobileProjectMenu />
      <div className="project-image-container">
        <img src={imageSrc} className="project-image" alt={`${title} Set`} />
      </div>

      <div className="project-body">
        <h1 className="project-text" id="project-role">
          {role}
        </h1>
        <h1 className="project-text" id="project-title">
          {title}
        </h1>
        <h1 className="project-text" id="project-billing">
          {billing}
        </h1>
      </div>
    </div>
  );
}

export default Project;
